import { Fragment, useContext, useEffect } from "react";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import CustomText from "../atomic/CustomText";
import CloseIcon from "../../assets/svg/CloseIcon";
import useInfoSlider from "../../services/utils/custom hooks/useInfoSlider";
import LoadingSvg from "../../assets/svg/LoadingSVG";
import InfoSliderLoadingIndicator from "./LoadingIndicators/InfoSliderLoadingIndicator";
import { useHistory } from "react-router-dom";

function InfoSlider() {
  const {
    state: { showInfoSlider, infoQuery },
    dispatch,
  } = useContext(ApplicationState);
  const { isFetching, data, isError } = useInfoSlider();
  const infoData = data?.data?.find((section) => section.key === infoQuery);
  const history = useHistory();

  useEffect(() => {
    const listener = (location: any, action: string) => {
      if (action === "PUSH" || action === "POP" || action === "REPLACE") {
        dispatch({ type: "HIDE_INFO_SLIDER", payload: undefined });
      }
    };
    history.listen(listener);
  }, []);

  function hideSlider() {
    dispatch({ type: "HIDE_INFO_SLIDER", payload: undefined });
  }

  return (
    <div className="md:h-[calc(100vh_-_115.5px)] h-[calc(100vh_-_135px)] max-w-[70vw] md:max-w-[25vw] min-w-[25vw] z-[99999999999] bg-white absolute right-0 md:top-[115.5px] top-[135px] border border-t-0  shadow-md overflow-auto">
      {!isFetching && (
        <Fragment>
          <div className="flex justify-between items-center border-b p-6 sticky top-0 bg-white">
            <CustomText
              text={infoData?.title}
              fontWeight="font-medium"
              fontSize="text-xl"
            />

            <button className="" onClick={hideSlider}>
              <CloseIcon fontSize={"text-3xl"} />
            </button>
          </div>
          <div
            className="p-6"
            dangerouslySetInnerHTML={{
              __html: infoData?.content ?? "",
            }}
          />
        </Fragment>
      )}
      {isFetching && <InfoSliderLoadingIndicator />}
    </div>
  );
}
export default InfoSlider;
